import { authedGet, authedPost, authedPut, authedDelete } from "./api";
import {
  api_v3_get_streaming_by_match,
  api_v3_create_streaming_by_match,
  api_v3_update_streaming_by_match,
  api_v3_delete_streaming_by_match,
} from "../utils/constants";

export const getStreamingByMatch = async (matchId, token) => {
  const url = api_v3_get_streaming_by_match(matchId);
  return authedGet(url, token);
};

export const createStreamingByMatch = async (data, token) => {
  const url = api_v3_create_streaming_by_match();
  return authedPost(url, data, token);
};

export const updateStreamingByMatch = async (matchStreamingId, data, token) => {
  const url = api_v3_update_streaming_by_match(matchStreamingId);
  return authedPut(url, data, token);
};

export const deleteStreamingByMatch = async (matchStreamingId, token) => {
  const url = api_v3_delete_streaming_by_match(matchStreamingId);
  return authedDelete(url, token);
};
